import { Button } from "@workspace/frontend-ui";
import type { FC } from "react";
import useRewardCenter from "../../actors/useRewardCenter";
import type { Reward } from "../../types";
import RewardPill from "./RewardPill";

type Props = {
  reward: Reward;
};

const RewardOptions: FC<Props> = ({ reward }) => {
  const { send } = useRewardCenter();

  return (
    <div data-slot="reward-options" className="flex flex-col gap-1.5 px-3 pb-3">
      {reward.options?.map((option) => (
        <Button
          key={option.id}
          variant="unstyled"
          aria-pressed={option.id === reward.chosenOptionId}
          className="h-auto justify-start gap-1.5 rounded-xl border-t border-t-foreground/5 bg-foreground/5 p-2 hover:bg-foreground/10 aria-pressed:bg-primary/15"
          onClick={() =>
            send("rewardCenter", {
              type: "chooseRewardOption",
              id: reward.id,
              optionId: option.id,
            })
          }
        >
          {option.items.map((item) => (
            <RewardPill key={item.label} item={item} />
          ))}
        </Button>
      ))}
    </div>
  );
};

export default RewardOptions;
